import { render, staticRenderFns } from "./msButton.vue?vue&type=template&id=ecb21b98&scoped=true"
import script from "./msButton.vue?vue&type=script&lang=js"
export * from "./msButton.vue?vue&type=script&lang=js"
import style0 from "./msButton.vue?vue&type=style&index=0&id=ecb21b98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecb21b98",
  null
  
)

export default component.exports